import { createFileRoute } from "@tanstack/react-router";

import { LandingPage } from "@/components/landing/landing-page";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "Innovally — Gestão simples para restaurantes" },
      {
        name: "description",
        content:
          "Venda pelo seu canal próprio, fique com 100% do valor da venda e organize garçom, balcão, PDV, mesas e delivery em um só sistema.",
      },
      { property: "og:title", content: "Innovally — Gestão simples para restaurantes" },
      {
        property: "og:description",
        content:
          "Uma plataforma segura, sem fidelidade e com suporte humano para restaurantes venderem mais pelo canal próprio e perderem menos comissões.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: LandingPage,
});